"use client";

import React from "react";
import { faArrowCircleLeft } from "@fortawesome/pro-solid-svg-icons";
import { useRouter } from "next/navigation";

import Button from "@/components/button";

const BackButton = () => {
  const router = useRouter();

  const onClick = () => {
    router.back();
  };

  return (
    <Button icon={faArrowCircleLeft} onClick={onClick}>
      Back
    </Button>
  );
};

export default BackButton;
